import { c as _c } from "react/compiler-runtime";
import React from "react";
import WaveWinnersDropHeaderTotalVotes from "./WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./WaveWinnersDropHeaderVoters";
import WaveWinnersDropHeaderAuthorHandle from "./WaveWinnersDropHeaderAuthorHandle";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
interface WaveWinnersDropHeaderProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly showVotingInfo?: boolean;
}
export const WaveWinnersDropHeader: React.FC<WaveWinnersDropHeaderProps> = t0 => {
  const $ = _c(20);
  const {
    winner,
    showVotingInfo: t1
  } = t0;
  const showVotingInfo = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== winner) {
    t2 = <WaveWinnersDropHeaderAuthorHandle winner={winner} />;
    $[0] = winner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== winner.drop.created_at) {
    t4 = <WaveDropTime timestamp={winner.drop.created_at} />;
    $[3] = winner.drop.created_at;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t3}{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = winner.drop.winning_context?.decision_time || null;
  let t7;
  if ($[8] !== t6 || $[9] !== winner.place) {
    t7 = <WinnerDropBadge rank={winner.place} decisionTime={t6} />;
    $[8] = t6;
    $[9] = winner.place;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-items-start tw-gap-y-2.5 tw-w-full xl:tw-w-auto">{t5}{t7}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== showVotingInfo || $[15] !== winner) {
    t9 = showVotingInfo && <div className="tw-whitespace-nowrap tw-mt-1 sm:tw-mt-0"><div className="tw-flex tw-items-center tw-flex-wrap xl:tw-flex-nowrap tw-gap-x-2 sm:tw-gap-x-4 tw-gap-y-2"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div></div>;
    $[14] = showVotingInfo;
    $[15] = winner;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <div onClick={_temp} className="tw-flex tw-flex-wrap xl:tw-flex-nowrap tw-gap-y-2 tw-justify-between tw-w-full">{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
function _temp(e) {
  return e.stopPropagation();
}